import React, { useContext, useState } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { fullDateWithMonthName } from '../../../utils/dateTimeUtil';
import { PropTypes } from 'prop-types';
import ADD_ICON from '../../../assets/images/add.png';
import { Options, AlertDialog } from '../../UI';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
const styles = makeStyles({
    mainContainer: {
        height: 'calc(100vh - 160px)',
        backgroundColor: '#f5f7fa',
        marginLeft: '26px',
        borderRadius: '6px',
        padding: '5px 0',
        position: 'sticky',
        top: '0',
        overflowX: 'visible',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px'
        }
    },
    emptyText: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'gray',
        textAlign: 'center',
        '& p': {
            padding: '10px',
            lineHeight: '1.5em'
        }
    },
    loaderContainer: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    loader: {
        width: '25px !important',
        height: '25px !important'
    },
    formItem: {
        position: 'relative',
        textAlign: 'center',
        padding: '5px 0',
        margin: '0 7px 5px',
        backgroundColor: 'white',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'solid 2px white',
        boxShadow: '0 3px 5px 0 rgba(34, 34, 34, 0.32)',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#f7fbff',
            border: 'solid 2px #f7fbff',
            boxShadow: '0 1px 3px 0 rgba(34, 34, 34, 0.32)'
        }
    },
    activeItem: {
        position: 'relative',
        textAlign: 'center',
        padding: '5px 0',
        margin: '0 7px 5px',
        borderRadius: '6px',
        border: 'solid 2px #1b90fa',
        backgroundColor: '#f6fbff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 3px 5px 0 rgba(34, 34, 34, 0.32)'
    },
    plusImg: {
        marginLeft: '7px'
    },
    plusText: {
        color: '#1b90fa'
    },
    hiddenOption: {
        visibility: 'hidden',
        width: '0',
        height: '0',
        overflow: 'hidden'
    }
});
const HistoryFormList = ({ forms, selectedFormId, ...props }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles();
    const options = [{ label: messages.delete, icon: 'delete', value: 1 }];
    const handleSelect = (option) => {
        if (option.value === 1) {
            toggleDialog();
        }
    };
    const toggleDialog = () => {
        if (!dialog) {
            setAlertText(getAlertText());

            setDialog(true);
        } else {
            setDialog(false);
        }
    };
    const getAlertText = () => {
        if (selectedForm.patient) {
            if (lang === 'fa') {
                return `آیا از حذف فرم  ${selectedForm.patient?.first_name} ${
                    selectedForm.patient?.last_name
                } در تاریخ ${fullDateWithMonthName(selectedForm.created)} اطمینان دارید؟`;
            } else {
                return `Are you sure about deleting form of ${selectedForm.patient?.first_name} ${
                    selectedForm.patient?.last_name
                } at ${fullDateWithMonthName(selectedForm.created)} ?`;
            }
        } else {
            if (lang === 'fa') {
                return `آیا از حذف کردن فرم  تاریخ ${fullDateWithMonthName(
                    selectedForm.created
                )} اطمینان دارید؟`;
            } else {
                return `Are you sure about deleting form at ${fullDateWithMonthName(
                    selectedForm.created
                )}?`;
            }
        }
    };
    const handleDeleteForm = () => {
        props.handleDeleteForm(selectedForm?.id);
        setDialog(false);
        setSelectedForm(null);
    };
    const [selectedForm, setSelectedForm] = useState(null);
    const [alertText, setAlertText] = useState('آیا مطمئنی؟');
    const [dialog, setDialog] = useState(false);
    return (
        <div className={classes.mainContainer}>
            {forms === null ? (
                <div className={classes.loaderContainer}>
                    <CircularProgress className={classes.loader} />
                </div>
            ) : forms && forms.length === 0 ? (
                <div className={classes.emptyText}>
                    <p>{messages.noFormSubmitted}</p>
                </div>
            ) : (
                <>
                    <div
                        onClick={() => props.handleSelectForm()}
                        className={selectedFormId ? classes.formItem : classes.activeItem}
                    >
                        <img className={classes.plusImg} width={20} alt="add" src={ADD_ICON} />
                        <span className={classes.plusText}>{messages.newForm}</span>
                    </div>
                    {forms.map((form) => (
                        <div
                            className={
                                selectedFormId === form.id ? classes.activeItem : classes.formItem
                            }
                            key={form.id}
                            onMouseEnter={() => {
                                setSelectedForm(form);
                            }}
                            onClick={() => {
                                setSelectedForm(form);
                                props.handleSelectForm(form.id);
                            }}
                        >
                            {fullDateWithMonthName(form?.created)}

                            {selectedForm?.id === form.id && (
                                <Options
                                    className={
                                        selectedForm?.id === form.id || selectedFormId === form.id
                                            ? ''
                                            : classes.hiddenOption
                                    }
                                    top={'0'}
                                    right={'5'}
                                    width={20}
                                    options={options}
                                    handleClose={() => setDialog(false)}
                                    handleSelect={handleSelect}
                                />
                            )}
                        </div>
                    ))}
                    <AlertDialog
                        open={dialog}
                        alertText={alertText}
                        cancelText={messages.no}
                        confirmText={messages.yes}
                        handleAction={handleDeleteForm}
                        handleClose={toggleDialog}
                    />
                </>
            )}
        </div>
    );
};
HistoryFormList.propTypes = {
    forms: PropTypes.array,
    handleSelectForm: PropTypes.func,
    handleDeleteForm: PropTypes.func,
    selectedFormId: PropTypes.number
};
export default HistoryFormList;
